import { useMemo } from 'react'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { PRAKTIK_KINERJA_STEP_ORDER } from 'app/KinerjaGpkPage/constants/praktik-kinerja-steps'
import { PraktikKinerjaStepCard } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'
import { PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

import type { StepCardStatus } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'
import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

type ObservasiStepCardProps = {
  state?: TStatePelaksanaan
}

const STEP: TStatePelaksanaan = 'OBSERVATION_IMPLEMENTATION'

export function ObservasiStepCard({ state }: ObservasiStepCardProps) {
  // ----------------------------------------------------
  // Resolve step card status
  // ----------------------------------------------------
  const stepCardStatus: StepCardStatus = useMemo(() => {
    const currentStepIndex = PRAKTIK_KINERJA_STEP_ORDER.indexOf(state)
    const observasiStepIndex = PRAKTIK_KINERJA_STEP_ORDER.indexOf(STEP)

    if (currentStepIndex > observasiStepIndex) return 'completed'
    if (currentStepIndex === observasiStepIndex) return 'active'
    return 'locked'
  }, [state])

  return (
    <PraktikKinerjaStepCard
      className="max-w-96"
      actions={
        <NextLink
          href={`${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/observasi`}
          passHref
        >
          <Button
            as="a"
            size="lg"
            color={stepCardStatus === 'active' ? 'blue' : 'white'}
            className="!inline-flex"
            type={undefined}
          >
            Cek rincian
          </Button>
        </NextLink>
      }
      iconSrc="/illustrations/img-observation-class-check.png"
      status={stepCardStatus}
      lockedHint="Dilakukan setelah isi Diskusi Persiapan."
      title={
        <>
          Pemantauan Kinerja: <br /> Observasi Praktik Kinerja
        </>
      }
      description="Observasi akan dilaksanakan sesuai jadwal"
    />
  )
}
